import { environment } from '@environments/environment';
var INDRABookingStep = /** @class */ (function () {
    function INDRABookingStep(departure, destination, date, bound) {
        this.flight_selected = false;
        this.date_selected = false;
        this._departure = departure;
        this._destination = destination;
        this._bound = bound;
        if (date) {
            this._date = date;
        }
        else {
            this._date = null;
        }
    }
    Object.defineProperty(INDRABookingStep.prototype, "departure", {
        get: function () {
            return this._departure;
        },
        set: function (newDeparture) {
            this._departure = newDeparture;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRABookingStep.prototype, "destination", {
        get: function () {
            return this._destination;
        },
        set: function (newDestination) {
            this._destination = newDestination;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRABookingStep.prototype, "date", {
        get: function () {
            if (this._date) {
                return this._date;
            }
            else {
                return null;
            }
        },
        set: function (value) {
            if (value instanceof Date) {
                var date = new Date(value);
                this._date = date;
            }
            else {
                this._date = null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRABookingStep.prototype, "bound", {
        get: function () {
            if (this._bound) {
                return this._bound;
            }
            else {
                return null;
            }
        },
        set: function (bound) {
            this._bound = bound;
        },
        enumerable: true,
        configurable: true
    });
    INDRABookingStep.prototype.showDate = function () {
        var date = new Date(this._date);
        if (date) {
            return date.toLocaleDateString(environment.locale, {
                month: 'long',
                day: 'numeric'
            });
        }
        else {
            return '--/--/----';
        }
    };
    Object.defineProperty(INDRABookingStep.prototype, "time", {
        get: function () {
            var date = new Date(this._date);
            if (this.flight_selected) {
                return date.toLocaleTimeString(environment.locale, {
                    hour: 'numeric',
                    minute: 'numeric'
                });
            }
            else {
                return '--:--';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRABookingStep.prototype, "done", {
        get: function () {
            return !!this._date;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRABookingStep.prototype, "codeDestination", {
        get: function () {
            return this._destination.code;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRABookingStep.prototype, "codeDeparture", {
        get: function () {
            return this._departure.code;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRABookingStep.prototype, "nameDestination", {
        get: function () {
            return this._destination.city;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(INDRABookingStep.prototype, "nameDeparture", {
        get: function () {
            return this._departure.city;
        },
        enumerable: true,
        configurable: true
    });
    INDRABookingStep.prototype.toString = function () {
        return (this._departure.code +
            ' -> ' +
            this._destination.code +
            ' on ' +
            this.date +
            ' at ' +
            this.time);
    };
    Object.defineProperty(INDRABookingStep.prototype, "cost", {
        get: function () {
            return this._cost;
        },
        set: function (newCost) {
            this._cost = newCost;
        },
        enumerable: true,
        configurable: true
    });
    return INDRABookingStep;
}());
export { INDRABookingStep };
